import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';
import flexbox from 'styles/utils/flexbox';

function LayoverComponent({ layoverTime, airlineWhitelabel }) {
  return (
    <Root>
      <LayoverTime>{layoverTime}</LayoverTime>
      <Decoration>
        <Line />
      </Decoration>
      <LayoverMessage airlineWhitelabel={airlineWhitelabel}>
        <FormattedMessage id={'layover.label'} description={'Layover'} defaultMessage={'Layover'} />
      </LayoverMessage>
    </Root>
  );
}

export default LayoverComponent;

const Root = styled.div`
  ${flexbox({
    justifyContent: 'space-between',
    alignItems: 'center',
  })}

  height: 52px;
  width: 336px;
  padding: 0 20px;
  box-sizing: content-box;
`;

const LayoverTime = styled.div`
  ${flexbox({
    flexDirection: 'column',
    justifyContent: 'space-between',
  })}
  width: 50%;
  font-size: 1.4em;
  font-weight: 500;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.adjacent.default};
`;

const Decoration = styled.div`
  ${flexbox({
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  })}
  height: 100%;
  width: 50%;
`;

const Line = styled.div`
  height: 100%;
  border-right: 1px dashed ${({ theme }) => theme.colors.secondary.default};
`;

const LayoverMessage = styled.div`
  flex: 1 0 75%;
  font-size: 1.6em;
  font-weight: ${({ airlineWhitelabel }) => (airlineWhitelabel && airlineWhitelabel.isAirBaltic ? 500 : 700)};
  color: ${({ theme }) => theme.colors.adjacent.default};
`;
